export { default } from './MultiSliderCalculator';
